module.exports = __webpack_public_path__ + "static/media/studentLogin2.842f0e7a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Instructions/studentLogin2.gif
// module id = 1249
// module chunks = 2